import React, { Component } from "react";
import styled from "styled-components";
import NanoFlex from "../Global/NanoFlex";
import Type from "../Global/Typography.js";

const StyledTextarea = styled(NanoFlex)`
  gap: 10px;

  .title {
    color: ${(props) => props.theme.color.primaryColors.fontColor};
    font-weight: 600;
    text-transform: uppercase;
  }
  textarea {
    border: 1px solid ${(props) => props.theme.color.primaryColors.lightGrey};
    border-radius: 15px;
    padding: 12px 20px;
    width: 100%;
    height: 136px;
    font-size: 18px;
    color: ${(props) => props.theme.color.main.font};
    font-family: ${(props) => props.theme.font};
    resize: none;

    &::-webkit-scrollbar {
      display: none;
    }

    /* MEDIA QUERIES */
    @media only screen and (max-width: 1450px) {
      font-size: 14px;
    }

    @media only screen and (max-width: 1024px) {
      font-size: 12px;
    }

    &::placeholder {
      font-family: ${(props) => props.theme.font};
      color: ${(props) => props.theme.color.primaryColors.secFontColor};
    }
    &:focus {
      border: 1px solid ${(props) => props.theme.color.primaryColors.lightPurple};
    }
  }
`;

class Textarea extends Component {
  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.inputRef.current.value = this.props.defaultValue;
    }
  }

  render() {
    return (
      <StyledTextarea className="TextAreaContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
        {this.props.title && <Type.p className="title">{this.props.title}</Type.p>}
        <NanoFlex className="TextAreaWrapper">
          <textarea
            ref={this.inputRef}
            type={this.props.title}
            placeholder={this.props.placeholder}
            defaultValue={this.props.defaultValue}
            onChange={(e) => {
              if (this.props.onChangeAction) {
                this.props.onChangeAction(e.target.value);
              }
            }}></textarea>
        </NanoFlex>
      </StyledTextarea>
    );
  }
}

// Set default props
Textarea.defaultProps = {
  title: "Title",
  placeholder: "placeholder",
};

export default Textarea;
